import React, { useState, useEffect } from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    Card,
    styled,
    Stack,
    FormHelperText,
    MenuItem,
    Select,
    FormControl,
    InputLabel
} from '@mui/material';

import { green } from "@mui/material/colors";

// import {
//     LoadingButton
// } from '@mui/lab';

import dayjs from "dayjs";

import { useNavigate } from "react-router-dom";

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../context/AppContext";

import { useAuthAccess } from "../../../hooks/useAuthAccess";

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from "../../common/CommonRestricted";
import DatePickerComponent from "../../common/DatePickerComponent";
import LocationSelector from "../../selector/LocationSelector";

import SearchItems from "../../dialog/SearchItems";
// import SearchDocuments from "../../dialog/SearchDocuments";
import SearchCustomers from "../../dialog/SearchCustomers";
import { useStateCashSales } from "../../../hooks/state/loadFrom/documents/useStateCashSales";

import { usePaymentMethods } from "../../../hooks/api/usePaymentMethods";
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
import { useTranslations } from '../../../hooks/useTranslations';

import { useSystemUtils } from "../../../hooks/useSystemUtils";
import { useDocuments, documentTypes, targetTypes } from "../../../hooks/api/useDocuments";
import { useStateInventoryBatches } from "../../../hooks/state/useStateInventoryBatches";
import { CommonIcons, icons } from "../../common/CommonIcons";
import { checkValueExists } from "../../../utils/dataSchema";

import { useDocumentAdjustments } from "../../../hooks/state/useDocumentAdjustments";

import {
    loadFromDocumentTypes,
    LoadFromDocuments
} from "../../dialog/LoadFromDocuments";

import {
    validationSchema,
    initialValues,
    initialRowValues
} from "../../../schema/documents/cashSalesSchema"

import { initialValues as initialValuesPayment } from "../../../schema/documents/paymentSchema";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

export default function NewCashSales({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const navigate = useNavigate()

    const { getLocationIds, setLocationIds } = useAppContextFeatures();

    const { authData, getAvailableLocations } = useAuthAccess();

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.cashSales.id)

    const { setSystemLoading } = useAppContextFeatures();
    const { list: listPaymentMethods } = usePaymentMethods();
    const { create } = useDocuments({ documentType: documentTypes.cashSales, targetType: targetTypes.cashSales })
    const { updateFormikState, getFormikDependencyStates } = useStateCashSales()

    const [dataBranches, setDataBranches] = useState([])
    const [dataShipping, setDataShipping] = useState([])

    const [loadDocumentConfig, setLoadDocumentConfig] = useState({
        show: false,
        documentId: loadFromDocumentTypes.cashSales.id,
        documentType: loadFromDocumentTypes.cashSales.type,
        keyword: ""
    })

    const [paymentMethods, setPaymentMethods] = useState([])
    const { formatCurrencyDisplay, currencyAbb } = useSystemUtils()

    const [selectLocationIds, setSelectLocationIds] = useState()

    const [preview, setPreview] = useState(false)

    const availableLocations = getAvailableLocations();

    useEffect(() => {

        fetchPaymentMethods();

    }, [])

    const fetchPaymentMethods = () => {

        setSystemLoading(true);

        try {

            let response = listPaymentMethods();

            setPaymentMethods(response?.data.paymentMethods)

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        const document = {
            doc_date: currentValues.documentDate.format("YYYY-MM-DD"),
            doc_remark: currentValues.remark,
        }

        const profiles = {
            customer: {
                user_id: currentValues.userId
            },
            shipping_address: {
                branch_id: currentValues.shippingBranchId
            },
            billing_branch: {
                branch_id: currentValues.billingBranchId
            }
        }

        const payment = {
            ...initialValuesPayment,
            payment_date: dayjs().format("YYYY-MM-DD"),
            payment_post_date: dayjs().format("YYYY-MM-DD"),
            payment_action: "cash_sales",
            payment_reference: currentValues?.paymentReference,
            payment_type: currentValues.paymentId.toLowerCase(),
            bank_name: currentValues.paymentName,
            bank_account_name: currentValues.paymentTypeName,
            bank_account_no: currentValues.paymentTypeId,
            receive_amount: currentValues.receiveAmount
        }

        const amounts = {
        }

        const props = {
            location_id: currentValues.locationId,

        }

        let items = [];

        currentValues.rows.map((item, index) => {

            // get the saved inventory batched selection from hook state
            const selected = getSelectedInventoryBatch({ selectedIndexNo: index })

            let deductions = {}

            if (selected?.batchId !== skipBatchId) {
                // console.log('selected', selected)
                deductions = {
                    slot: selected?.slotId,
                    custom_batch_no: selected?.customBatchNo ? selected.customBatchNo : '',
                    expiry_date: selected?.expiryDate ? selected.expiryDate : ''
                }
            }

            items.push({
                id: item?.itemId,
                code: item?.code,
                name: item?.name,
                description: item?.description,

                qty: item?.qty?.value,

                uom_lbl: item?.uomName,
                uom: item?.uomId,
                price: item?.price,
                deductions
            })
            return false;
        })

        let adjustments = getPayloadSubmitCreate()

        try {

            let data = {
                document,
                profiles,
                payment,
                amounts,
                props,
                items,
                adjustments,
                ...getFormikDependencyStates({ values })
            }

            // console.log('data', data)

            const response = await create({ data });

            // console.log('response', response)

            promptMessage(true, `${response?.message}`)

            navigate(getRoute("documents/cashSales"))

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit
    });

    const {
        getAmount,
        calculateSummaryRows,
        updateTaxPreviewOpen,
        RenderDocumentSummary,
        RenderDocumentTaxPreview,
        getPayloadSubmitCreate
    } = useDocumentAdjustments({
        formik,
        documentType: documentTypes.cashSales,
        handlePreviewChange: (val) => {
            // console.log('current open', val)
            setPreview(val)
        }
    })

    useEffect(() => {

        updateTaxPreviewOpen(preview)

    }, [preview])

    const {
        handleSubmit, handleChange, values, errors, touched, setFieldValue,
    } = formik

    const {
        isLoading: isLoadingInventoryBatches,
        skipBatchId,
        // skipIndexNoArray,
        // dataInventoryBatches,
        resetDataInventoryBatches,
        selectInventoryBatch,
        getInventoryBatchesByItemId,
        getSelectedInventoryBatch,
        appendInventoryBatch,
        removeAllSelectedIndexNo,
        RenderValueComponent,
        RenderSubHeaderComponent,
        RenderMenuItemComponent,
    } = useStateInventoryBatches({
        locationId: values.locationId
    })

    useEffect(() => {

        calculateSummaryValues({
            setFieldValue,
            values
        });

    }, [values])

    useEffect(() => {

        const currentLocationIds = getLocationIds();

        setSelectLocationIds(currentLocationIds)

        if (currentLocationIds.length > 0) {
            // console.log('currentLocationIds', currentLocationIds, availableLocations)

            // get the location information
            const loc = availableLocations.filter(item => item.id === currentLocationIds[0])

            if (loc.length) {
                setFieldValue("locationId", loc[0].id)
                setFieldValue("locationName", loc[0].location_name)
                // setFieldValue("retailOutletBranchId", loc[0].branch_id)
            }
        }

    }, [getLocationIds])

    const getBreadcumbActionMenus = () => {

        let props = []

        if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
            props.push({
                displayText: t("loadFrom"),
                onClick: () => {

                    // check the location is selected - valid
                    if (validateLocationSelection() === false) {
                        promptMessage(false, t(`pleaseSelectAnyLocation`))
                        return false;
                    }

                    setLoadDocumentConfig(prev => ({ ...prev, show: true }))

                    return true;

                }
            })
        }

        return props
    }

    const updateStateFromSearchDocument = (props) => {

        try {

            // check the location is selected - valid
            if (validateLocationSelection() === false) {
                promptMessage(false, t(`pleaseSelectAnyLocation`))
                return false;
            }

            updateFormikState({
                data: props?.data,
                routeType,
                setFieldValue,
                setDataBranches,
                setDataShipping
            })


        } catch (error) {
            promptMessage(false, `Load failed : ${error}`)
        }

        return true;
    }

    const getChangeAmount = () => {

        let _a = getAmount()

        const receive = values?.receiveAmount ? parseFloat(values.receiveAmount) : 0
        const total = _a?.netAmount ? parseFloat(_a.netAmount) : 0

        const val = parseFloat(receive - total)

        return val
    }

    const validateLocationSelection = () => {
        const selected = getLocationIds()
        return selected && selected.length === 1
    }

    const calculateSummaryValues = () => {

        if (!values) return false;

        try {
            calculateSummaryRows({
                handleValueRow: ({ subTotal, index }) => {
                    setFieldValue(`rows.${index}.subtotal`, subTotal.toFixed(2))
                }
            })
        } catch (error) {
            promptMessage(false, `Error in summary calculation : ${error}`)
        }

        return true;

    }

    const handleAddItem = () => {

        let rows = values?.rows

        rows.push(initialRowValues);
        setFieldValue('rows', rows)

    }

    const handleRemoveItem = ({ index }) => {

        const currentLine = values.rows ? values.rows.length : 0;

        if (currentLine <= 1) {
            promptMessage(false, t(`itemsAtLeastHave1Row`))
            return false;
        }

        const rows = values?.rows;
        const newRows = rows.filter((i, ind) => ind !== index)

        // rows.remove(index);
        setFieldValue('rows', newRows)

        removeAllSelectedIndexNo({ selectedIndexNo: index })

        return true;

    }

    // able to filter out the inventory batches been selected even for the same uom id
    const getAvailableInventoryBatches = ({ index, itemId }) => {

        return getInventoryBatchesByItemId({ itemId, selectedIndexNo: index })
    }

    const RenderRows = () => {

        if (!values) return <></>

        const rows = values?.rows;

        return (
            <Box
            >
                <Box
                >
                    {
                        rows && rows.length > 0
                        && rows.map((item, index) => {

                            const itemValues = item;
                            let itemTouched = touched?.rows
                            let itemErrors = errors?.rows
                            // const itemTouched = touched?.rows

                            if (itemTouched) {
                                itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
                            }

                            if (itemErrors) {
                                itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                            }

                            return (
                                <Grid key={index} item xs={12} sm={12} md={12}>

                                    {/* {
                                        JSON.stringify(skipIndexNoArray)
                                    }
                                    {
                                        JSON.stringify(getSelectedInventoryBatch({ selectedIndexNo: index }))
                                    } */}

                                    <Grid container spacing={1} >

                                        <Grid item xs={12} sm={12} md={0.5} display={"flex"} flexDirection={"column"} justifyContent={"flex-start"} alignItems={"center"}>
                                            <IconButton
                                                aria-label="delete"
                                                onClick={() => handleRemoveItem({ index, setFieldValue })}
                                                sx={{
                                                    mt: 1
                                                }}
                                            >
                                                <CommonIcons name={icons.remove} />
                                            </IconButton>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={2.5}>

                                            <SearchItems
                                                id={`rows.${index}.name`}
                                                handleOnCancel={() => { }}
                                                handleOnSearchChange={(event) => {
                                                    setFieldValue(`rows.${index}.name`, `${event.target.value}`)
                                                }}
                                                handleOnSelect={async ({ id, item }) => {

                                                    // const inventoryBatches = await fetchInventoryBatch({ itemId: item?.id})

                                                    appendInventoryBatch({ itemId: item?.id, selectedIndexNo: index })

                                                    // console.log('inventoryBatches', inventoryBatches)

                                                    setFieldValue(`rows.${index}.itemId`, item?.id)
                                                    setFieldValue(`rows.${index}.name`, item?.item_name)
                                                    setFieldValue(`rows.${index}.description`, item?.description)
                                                    setFieldValue(`rows.${index}.code`, item?.code)
                                                    setFieldValue(`rows.${index}.uomName`, item?.uom_name)
                                                    setFieldValue(`rows.${index}.uomId`, item?.uom_id)
                                                    setFieldValue(`rows.${index}.qty`, { value: "0", maxQty: parseFloat(0), skipStockPost: true })
                                                    setFieldValue(`rows.${index}.price`, item?.uom_price)
                                                    // setFieldValue(`rows.${index}.inventoryBatches`, inventoryBatches)
                                                }}
                                                textProps={{
                                                    disabled: true,
                                                    value: itemValues?.name ? itemValues.name : "",
                                                    error: Boolean(itemErrors?.name),
                                                    helperText: itemErrors?.name
                                                }}
                                            />

                                        </Grid>

                                        <Grid item xs={12} sm={12} md={2.5}>
                                            <TextField
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.description`}
                                                label={t("description")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.description ? itemValues.description : ""}
                                                onChange={handleChange}
                                                error={Boolean(itemErrors?.description)}
                                                helperText={itemErrors?.description}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={2.5}>

                                            {
                                                isLoadingInventoryBatches ?
                                                    (
                                                        <TextField
                                                            margin="dense"
                                                            size="small"
                                                            fullWidth
                                                            placeholder="Loading..."
                                                            type="text"
                                                            variant="outlined"
                                                        />
                                                    )
                                                    :
                                                    (
                                                        <FormControl
                                                            margin="dense"
                                                            fullWidth
                                                            size="small"
                                                            error={Boolean(itemErrors?.inventoryBatchId)}
                                                        >
                                                            <InputLabel id="inventoryBatchId">{t('inventory')}</InputLabel>
                                                            <Select
                                                                disabled={
                                                                    !(itemValues?.itemId)
                                                                }
                                                                labelId="inventoryBatchId"
                                                                label={t('inventory')}
                                                                name={`rows.${index}.inventoryBatchId`}
                                                                // onChange={handleChange}
                                                                onChange={(event) => {

                                                                    let batchId = event.target.value

                                                                    const selectedBatch = selectInventoryBatch({
                                                                        itemId: itemValues.itemId,
                                                                        batchId,
                                                                        selectedIndexNo: index
                                                                    })

                                                                    setFieldValue(`rows.${index}.inventoryBatchId`, batchId)

                                                                    if (selectedBatch !== false) {
                                                                        setFieldValue(
                                                                            `rows.${index}.qty`,
                                                                            {
                                                                                value: "0",
                                                                                maxQty: parseFloat(selectedBatch?.totalRemainQty),
                                                                                skipStockPost: false
                                                                            }
                                                                        )
                                                                    } else { // for skip 
                                                                        setFieldValue(
                                                                            `rows.${index}.qty`,
                                                                            {
                                                                                value: "0",
                                                                                maxQty: "",
                                                                                skipStockPost: true
                                                                            }
                                                                        )
                                                                    }

                                                                }}
                                                                renderValue={(value) => {

                                                                    const a = getSelectedInventoryBatch({ selectedIndexNo: index })

                                                                    return (
                                                                        <RenderValueComponent item={a} />
                                                                    )
                                                                }}
                                                                value={
                                                                    getSelectedInventoryBatch({ selectedIndexNo: index })?.batchId ?
                                                                        getSelectedInventoryBatch({ selectedIndexNo: index }).batchId
                                                                        :
                                                                        ""
                                                                }
                                                                sx={{
                                                                    textAlign: 'left',
                                                                }}
                                                                MenuProps={{
                                                                    MenuListProps: {
                                                                        sx: {
                                                                            py: 0,
                                                                        },
                                                                    }
                                                                }}
                                                            >
                                                                {/* <RenderSubHeaderComponent /> */}
                                                                {
                                                                    getAvailableInventoryBatches({ index, itemValues, itemId: itemValues.itemId }).map((i, index2) => {
                                                                        return (
                                                                            <MenuItem
                                                                                key={index2}
                                                                                value={i.batchId}
                                                                                sx={{
                                                                                    textTransform: 'capitalize',
                                                                                }}
                                                                            >
                                                                                {i.label}
                                                                            </MenuItem>
                                                                            // RenderMenuItemComponent({
                                                                            //     key: index2,
                                                                            //     index: index2,
                                                                            //     item: i,
                                                                            //     style: {
                                                                            //         width: 500,
                                                                            //     }
                                                                            // })
                                                                        )
                                                                    })
                                                                }
                                                                {/* {
                                                                    getAvailableInventoryBatches({ index, itemValues, itemId: itemValues.itemId }).map((i, index) => {
                                                                        return (
                                                                            <MenuItem
                                                                                key={index}
                                                                                value={i.batchId}
                                                                                sx={{
                                                                                    textTransform: 'capitalize',
                                                                                }}
                                                                            >
                                                                                {i.label}
                                                                            </MenuItem>
                                                                        )
                                                                    })
                                                                } */}

                                                            </Select>
                                                            <FormHelperText>
                                                                {
                                                                    itemErrors?.inventoryBatchId ?
                                                                        itemErrors?.inventoryBatchId
                                                                        :
                                                                        getSelectedInventoryBatch({ selectedIndexNo: index })?.batchId ?
                                                                            getSelectedInventoryBatch({ selectedIndexNo: index }).label
                                                                            :
                                                                            ""
                                                                }
                                                            </FormHelperText>
                                                        </FormControl>
                                                    )
                                            }

                                        </Grid>

                                        {/* inventoryBatches */}
                                        <Grid item xs={12} sm={12} md={1.5}>
                                            <TextField
                                                disabled={
                                                    itemValues?.inventoryBatchId ? Boolean(false) : Boolean(true)
                                                }
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.qty`}
                                                label={`${t('qty')} ${itemValues?.uomName ? "(".concat(itemValues.uomName).concat(")") : ""}`}
                                                type="text"
                                                variant="outlined"
                                                value={
                                                    itemValues?.qty?.value ? itemValues.qty.value : ""
                                                }
                                                onChange={(event) => {
                                                    setFieldValue(
                                                        `rows.${index}.qty`,
                                                        {
                                                            value: event.target.value,
                                                            maxQty: parseFloat(itemValues.qty.maxQty),
                                                            skipStockPost: itemValues.qty.skipStockPost
                                                        }
                                                    )
                                                }}
                                                onFocus={event => {
                                                    event.target.select();
                                                }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            {
                                                                itemValues?.qty.skipStockPost === false && `/ ${itemValues?.qty?.maxQty}`
                                                            }
                                                        </InputAdornment>
                                                    )
                                                }}
                                                error={Boolean(itemErrors?.qty?.value)}
                                                helperText={itemErrors?.qty?.value}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1}>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                }}
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.price`}
                                                label={t("price")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.price ? itemValues.price : ""}
                                                onChange={(event) => {
                                                    setFieldValue(`rows.${index}.price`, event.target.value);
                                                }}
                                                error={Boolean(itemErrors?.price)}
                                                helperText={itemErrors?.price}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1.5}>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                }}
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                disabled
                                                name={`rows.${index}.subtotal`}
                                                label={t("subTotal")}
                                                value={itemValues?.subtotal ? itemValues.subtotal : "0.00"}
                                                type="text"
                                                variant="outlined"
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                </Box>

                <Grid item xs={12}>
                    <Divider sx={{ mt: 1, mb: 0 }} />
                </Grid>

                {
                    RenderSummaryRow({ values, errors, touched, handleChange, setFieldValue })
                }

            </Box>
        )
    }

    // const RenderDocumentSummary = () => {

    //     return (
    //         <Grid container rowSpacing={0} rowGap={0} columnSpacing={1}>

    //             <Grid item xs={12} sm={12} md={6}>
    //                 <></>
    //             </Grid>

    //             <Grid item xs={12} sm={12} md={6}>
    //                 <TextField
    //                     inputProps={{
    //                         style: {
    //                             textAlign: "right"
    //                         }
    //                     }}

    //                     InputProps={{
    //                         startAdornment: (
    //                             <InputAdornment position="start">
    //                                 <CommonIcons name={icons.equal} />
    //                             </InputAdornment>
    //                         ),
    //                     }}

    //                     margin="normal"
    //                     size="small"
    //                     fullWidth
    //                     name={"discount.amount"}
    //                     label={t("discount")}
    //                     type="text"
    //                     variant="outlined"
    //                     value={values.discount.amount}
    //                     onChange={(event) => {
    //                         setFieldValue(`discount.amount`, event.target.value);
    //                     }}
    //                     error={Boolean(errors?.discount?.amount)}
    //                     helperText={errors?.discount?.amount}
    //                 />
    //             </Grid>

    //             <Grid item xs={12} sm={12} md={6}>
    //                 <FormControl
    //                     margin="normal"
    //                     fullWidth
    //                     size="small"
    //                     error={Boolean(errors?.tax?.id)}
    //                 >
    //                     <InputLabel id="taxId">{t("tax")}</InputLabel>
    //                     <Select
    //                         labelId="taxId"
    //                         label={t("tax")}
    //                         name={"taxId"}
    //                         onChange={(event) => {
    //                             setFieldValue(`tax.id`, event.target.value)
    //                         }}
    //                         value={
    //                             checkValueExists({
    //                                 dataSearch: taxTypesArray,
    //                                 valueToCompare: values.tax.id
    //                             })
    //                         }
    //                         sx={{
    //                             textAlign: 'left'
    //                         }}
    //                     >
    //                         {
    //                             taxTypesArray.map((i, index) => {
    //                                 return (
    //                                     <MenuItem key={index} value={i.id}>{i.name}</MenuItem>
    //                                 )
    //                             })
    //                         }
    //                     </Select>
    //                     <FormHelperText>
    //                         {errors?.tax?.id}
    //                     </FormHelperText>
    //                 </FormControl>
    //             </Grid>

    //             <Grid item xs={12} sm={12} md={6}>
    //                 <TextField
    //                     inputProps={{
    //                         style: {
    //                             textAlign: "right"
    //                         }
    //                     }}
    //                     InputProps={{
    //                         startAdornment: (
    //                             <InputAdornment position="start">
    //                                 <CommonIcons name={icons.equal} />
    //                             </InputAdornment>
    //                         ),
    //                     }}
    //                     margin="normal"
    //                     size="small"
    //                     disabled
    //                     fullWidth
    //                     name={"tax.amount"}
    //                     label={t("taxAmount")}
    //                     type="text"
    //                     variant="outlined"
    //                     value={values?.tax?.amount ? values.tax.amount : "0.00"}
    //                 />
    //             </Grid>

    //             <Grid item xs={12} sm={12} md={6}>
    //                 <></>
    //             </Grid>

    //             <Grid item xs={12} sm={12} md={6}>

    //                 <TextField
    //                     inputProps={{
    //                         style: {
    //                             textAlign: "right"
    //                         }
    //                     }}
    //                     InputProps={{
    //                         startAdornment: (
    //                             <InputAdornment position="start">
    //                                 <CommonIcons name={icons.equal} />
    //                             </InputAdornment>
    //                         ),
    //                     }}
    //                     margin="normal"
    //                     size="small"
    //                     disabled
    //                     fullWidth
    //                     name={"totalamount"}
    //                     label={t("totalAmount")}
    //                     type="text"
    //                     variant="outlined"
    //                     value={values?.totalamount ? values.totalamount : "0.00"}
    //                 />
    //             </Grid>

    //         </Grid>
    //     )
    // }

    // const RenderSummaryRow = () => {
    //     return (
    //         <Grid item xs={12} sm={12} md={12}>

    //             <Grid container spacing={1}>

    //                 <Grid item xs={12} sm={12} md={4}>

    //                     <Button
    //                         variant="outlined"
    //                         sx={{ mt: 2 }}
    //                         fullWidth
    //                         startIcon={<CommonIcons name={icons.add} />}
    //                         onClick={() => handleAddItem()}
    //                     >
    //                         {t('addItem')}
    //                     </Button>

    //                 </Grid>

    //                 <Grid item xs={12} sm={12} md={5}>
    //                     <></>
    //                 </Grid>

    //                 <Grid item xs={12} sm={12} md={3}>
    //                     <TextField
    //                         // inputProps={{
    //                         //     style: {
    //                         //         textAlign: "right"
    //                         //     }
    //                         // }}

    //                         InputProps={{
    //                             startAdornment: (
    //                                 <InputAdornment position="start">
    //                                     <CommonIcons name={icons.equal} />
    //                                 </InputAdornment>
    //                             ),
    //                         }}

    //                         margin="normal"
    //                         size="small"
    //                         fullWidth
    //                         name={"discount.amount"}
    //                         label={t("discount")}
    //                         type="text"
    //                         variant="outlined"
    //                         value={values.discount.amount}
    //                         onChange={(event) => {
    //                             setFieldValue(`discount.amount`, event.target.value);
    //                         }}
    //                         error={Boolean(errors?.discount?.amount)}
    //                         helperText={errors?.discount?.amount}
    //                     />
    //                 </Grid>

    //             </Grid>

    //             <Grid container spacing={1}>

    //                 <Grid item xs={12} sm={12} md={7}>
    //                     <></>
    //                 </Grid>

    //                 <Grid item xs={12} sm={12} md={2}>
    //                     <FormControl
    //                         margin="normal"
    //                         fullWidth
    //                         size="small"
    //                         error={Boolean(errors?.tax?.id)}
    //                     >
    //                         <InputLabel id="taxId">{t('tax')}</InputLabel>
    //                         <Select
    //                             labelId="taxId"
    //                             label={t("tax")}
    //                             name={"taxId"}
    //                             onChange={(event) => {
    //                                 setFieldValue(`tax.id`, event.target.value)
    //                             }}
    //                             value={
    //                                 checkValueExists({
    //                                     dataSearch: taxTypesArray,
    //                                     valueToCompare: values.tax.id
    //                                 })
    //                             }
    //                             sx={{
    //                                 textAlign: 'left'
    //                             }}
    //                         >
    //                             {
    //                                 taxTypesArray.map((i, index) => {
    //                                     return (
    //                                         <MenuItem key={index} value={i.id}>{i.name}</MenuItem>
    //                                     )
    //                                 })
    //                             }
    //                         </Select>
    //                         <FormHelperText>
    //                             {errors?.tax?.id}
    //                         </FormHelperText>
    //                     </FormControl>
    //                 </Grid>

    //                 <Grid item xs={12} sm={12} md={3}>
    //                     <TextField
    //                         inputProps={{
    //                             style: {
    //                                 textAlign: "right"
    //                             }
    //                         }}
    //                         InputProps={{
    //                             startAdornment: (
    //                                 <InputAdornment position="start">
    //                                     <CommonIcons name={icons.equal} />
    //                                 </InputAdornment>
    //                             ),
    //                         }}
    //                         margin="normal"
    //                         size="small"
    //                         disabled
    //                         fullWidth
    //                         name={"tax.amount"}
    //                         label={t("taxAmount")}
    //                         type="text"
    //                         variant="outlined"
    //                         value={values?.tax?.amount ? values.tax.amount : "0.00"}
    //                     // onChange={handleChange}
    //                     // error={touched.total && Boolean(errors.total)}
    //                     // helperText={touched.total && errors.total}
    //                     />
    //                 </Grid>

    //             </Grid>

    //             <Grid container spacing={1}>

    //                 <Grid item xs={12} sm={12} md={9}>
    //                     <></>
    //                 </Grid>

    //                 <Grid item xs={12} sm={12} md={3}>
    //                     <TextField
    //                         inputProps={{
    //                             style: {
    //                                 textAlign: "right"
    //                             }
    //                         }}
    //                         InputProps={{
    //                             startAdornment: (
    //                                 <InputAdornment position="start">
    //                                     <CommonIcons name={icons.equal} />
    //                                 </InputAdornment>
    //                             ),
    //                         }}
    //                         margin="normal"
    //                         size="small"
    //                         disabled
    //                         fullWidth
    //                         name={"totalamount"}
    //                         label={t("totalAmount")}
    //                         type="text"
    //                         variant="outlined"
    //                         value={values?.totalamount ? values.totalamount : "0.00"}
    //                     // onChange={handleChange}
    //                     // error={touched.total && Boolean(errors.total)}
    //                     // helperText={touched.total && errors.total}
    //                     />
    //                 </Grid>

    //             </Grid>

    //         </Grid>
    //     )
    // }

    const RenderSummaryRow = ({ values, errors, touched, handleChange, setFieldValue }) => {
        return (
            <Grid item xs={12} sm={12} md={12}>

                <Grid container spacing={0.5}>

                    <Grid item xs={12} sm={12} md={4}>

                        <Button
                            variant="outlined"
                            sx={{ mt: 2 }}
                            fullWidth
                            startIcon={<CommonIcons name={icons.add} />}
                            onClick={() => handleAddItem({ rows: values.rows, setFieldValue })}
                        >
                            {t("addItem")}
                        </Button>

                    </Grid>

                    <Grid item xs={12} sm={12} md={3}>
                        <></>
                    </Grid>

                    <Grid item xs={12} sm={12} md={5}>

                        {
                            RenderDocumentSummary()
                        }

                    </Grid>

                </Grid>

            </Grid>
        )
    }

    const RenderFormProfile = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`profile`)}
                            subTitle={t(`relatedProfilesAttachedToDocument`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        <SearchCustomers
                            id={"searchCustomer"}
                            handleOnCancel={() => {

                            }}
                            handleOnSearchChange={(event) => {
                                setFieldValue('username', `${event.target.value}`)
                            }}
                            handleOnSelect={(props) => {

                                // reset state
                                setDataBranches([])
                                setDataShipping([])

                                const { id, item } = props

                                setFieldValue('username', `${item?.company_name} (${item?.username})`)
                                setFieldValue('userId', item?.user_id)

                                // update state
                                setDataBranches(item?.branches)
                                setDataShipping(item?.shipping_addresses)

                            }}
                            textProps={{
                                disabled: true,
                                value: values?.username,
                                error: Boolean(errors?.userId),
                                helperText: errors?.userId,
                            }}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={touched.billingBranchId && Boolean(errors.billingBranchId)}
                        >
                            <InputLabel id="rack-label">{t('billTo')}</InputLabel>
                            <Select
                                // labelId="rack-label"
                                // id="rack_id"
                                value={
                                    checkValueExists({
                                        dataSearch: dataBranches,
                                        valueToCompare: values?.billingBranchId
                                    })
                                }
                                name={`billingBranchId`}
                                label={t('billTo')}
                                margin="dense"
                                size="small"
                                onChange={(event) => {
                                    setFieldValue(`billingBranchId`, event.target.value)
                                }}
                            >
                                {
                                    dataBranches && dataBranches.map((item, index) =>
                                        <MenuItem key={index} value={item.id}>{item.branch_name}</MenuItem>
                                    )
                                }
                            </Select>
                            <FormHelperText>
                                {touched.billingBranchId && errors.billingBranchId}
                            </FormHelperText>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={touched.shippingBranchId && Boolean(errors.shippingBranchId)}
                        >
                            <InputLabel id="rack-label">{t('shipTo')}</InputLabel>
                            <Select
                                // labelId="rack-label"
                                // id="rack_id"
                                value={
                                    checkValueExists({
                                        dataSearch: dataShipping,
                                        valueToCompare: values?.shippingBranchId
                                    })
                                }
                                name={`shippingBranchId`}
                                label={t('shipTo')}
                                margin="dense"
                                size="small"
                                onChange={(event) => {
                                    setFieldValue(`shippingBranchId`, event.target.value)
                                }}
                            >
                                {
                                    dataShipping && dataShipping.map((item, index) =>
                                        <MenuItem key={index} value={item.id}>{item.branch_name}</MenuItem>
                                    )
                                }
                            </Select>
                            <FormHelperText>
                                {touched.shippingBranchId && errors.shippingBranchId}
                            </FormHelperText>
                        </FormControl>
                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormPayment = () => {
        return (
            <StyledCard>

                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`payment`)}
                            subTitle={t(`relatedPaymentAttachedToDocument`)}
                        />

                    </Grid>

                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                        <Grid container>
                            <Grid item md={6}>
                                <Grid container spacing={1}>
                                    <RenderPaymentMethods
                                        values={values}
                                        errors={errors}
                                        touched={touched}
                                        handleChange={handleChange}
                                        setFieldValue={setFieldValue}
                                    />
                                    {
                                        RenderPaymentTypes({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            setFieldValue
                                        })
                                    }
                                    <Grid item xs={12}>
                                        <TextField
                                            margin="dense"
                                            size="small"
                                            fullWidth
                                            name={"paymentReference"}
                                            label={t("reference")}
                                            type="text"
                                            variant="outlined"
                                            onChange={handleChange}
                                            value={values.paymentReference}
                                            error={touched.paymentReference && Boolean(errors.paymentReference)}
                                            helperText={touched.paymentReference && errors.paymentReference}
                                        />

                                    </Grid>
                                </Grid>


                            </Grid>
                            <Grid item md={1} xs={12} textAlign={"center"}>
                                <Divider orientation="vertical" variant="middle" textAlign="center">
                                    <StyledIcon sx={{ width: 30, height: 30, opacity: 0.3 }}>
                                        <CommonIcons name={icons.pay} />
                                    </StyledIcon>
                                </Divider>
                            </Grid>
                            <Grid item md={5} xs={12}>
                                <Grid container spacing={0}>
                                    <Grid item md={12} xs={12} sm={12}>
                                        <TextField
                                            fullWidth
                                            margin="dense"
                                            size="large"
                                            name={"receiveAmount"}
                                            label={t("receivableAmount")}
                                            type="number"
                                            variant="outlined"
                                            onChange={handleChange}
                                            value={values.receiveAmount}
                                            error={touched.receiveAmount && Boolean(errors.receiveAmount)}
                                            helperText={touched.receiveAmount && errors.receiveAmount}
                                            onFocus={event => {
                                                event.target.select();
                                            }}
                                            InputProps={{
                                                style: {
                                                    textAlign: 'right',
                                                },
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <CommonIcons name={icons.equal} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={4} sm={4} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography
                                            sx={{
                                                fontSize: 14
                                            }}
                                        >
                                            {`${t('change')}\n(${currencyAbb})`}
                                        </Typography>
                                    </Grid>
                                    <Grid item md={8} xs={8} sm={8} textAlign={"right"}>
                                        <Typography
                                            variant="h3"
                                            color={
                                                getChangeAmount() < 0 ?
                                                    "error" : green[600]
                                            }
                                            sx={{
                                                textAlign: 'right',
                                                // backgroundColor: 'red'
                                            }}
                                        >
                                            {
                                                formatCurrencyDisplay(getChangeAmount())
                                            }
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderPaymentMethods = () => {

        if (!paymentMethods) return <></>
        if (paymentMethods.length <= 0) return <></>

        return (
            <Grid item xs={12} sm={12} md={12} >

                <Stack
                    direction={"row"}
                    justifyContent={"flex-start"}
                    alignItems={"center"}
                    spacing={1}
                >
                    {
                        paymentMethods.map((item, index) => {
                            return (
                                <Button
                                    key={index}
                                    variant={item.id === values.paymentId ? "contained" : "outlined"}
                                    onClick={() => {

                                        // console.log('item', item, paymentMethods)

                                        setFieldValue('paymentId', item.id)
                                        setFieldValue('paymentName', item.name)

                                        // check if the cash selected
                                        if (item.id === "cash") {
                                            setFieldValue('paymentTypeId', "0")
                                            setFieldValue('paymentTypeName', "0")
                                        } else {
                                            setFieldValue('paymentTypeId', item.types.id)
                                            setFieldValue('paymentTypeName', item.types.name)
                                        }

                                    }}
                                >
                                    {item.name}
                                    <StyledIcon
                                        sx={{ ml: 0.5 }}
                                    >
                                        <CommonIcons name={icons[item.icon]} />
                                    </StyledIcon>
                                </Button>
                            )
                        })
                    }
                </Stack>

                <FormHelperText
                    error={Boolean(errors?.paymentId)}
                >
                    {errors?.paymentId}
                </FormHelperText>

            </Grid>
        )
    }

    const RenderPaymentTypes = () => {

        if (!paymentMethods) return <></>
        if (paymentMethods.length <= 0) return <></>

        // get the payment types from method selected
        const check = paymentMethods.filter(item => item.id === values.paymentId)

        if (check.length <= 0) return <></>;

        const paymentMethodTypes = check[0]?.types ? check[0].types : [];

        if (paymentMethodTypes.length <= 0) return <></>

        return (
            <Grid item xs={12} sm={12} md={12}>

                <Grid item xs={12} sm={12} md={12} textAlign={"left"} sx={{ mb: 1 }}>

                    <CommonSectionHeader
                        subTitle={t(`chooseTypes`)}
                    // subTitle={`Related payment attached to document`}
                    />

                </Grid>

                <Grid item xs={12} sm={12} md={12}>

                    <Stack
                        direction={"row"}
                        justifyContent={"flex-start"}
                        alignItems={"center"}
                        spacing={1}
                    >

                        {
                            paymentMethodTypes.map((item, index) => {
                                return (
                                    <Button
                                        key={index}
                                        variant={item.id === values.paymentTypeId ? "contained" : "outlined"}
                                        onClick={() => {
                                            setFieldValue('paymentTypeId', item.id)
                                            setFieldValue('paymentTypeName', item.name)
                                        }}
                                    >
                                        {item.name}
                                    </Button>
                                )
                            })
                        }
                    </Stack>

                    <FormHelperText
                        error={Boolean(errors?.paymentTypeId)}
                    >
                        {errors?.paymentTypeId}
                    </FormHelperText>

                </Grid>

            </Grid>
        )
    }

    const RenderFormDocument = () => {
        return (
            <StyledCard>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`document`)}
                            subTitle={t(`basicInformationAboutTheDocument`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={1}>

                            <Grid item xs={12} sm={12} md={10.5}>
                                <TextField
                                    disabled
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"locationId"}
                                    label={t("location")}
                                    type="text"
                                    variant="outlined"
                                    value={values.locationName}
                                    error={touched.locationId && Boolean(errors.locationId)}
                                    helperText={touched.locationId && errors.locationId}
                                />
                            </Grid>
                            <Grid item md={1.5}>
                                <IconButton
                                    color="primary"
                                    sx={{
                                        // pt: 0
                                    }}
                                    onClick={() => {
                                        setLocationIds([])
                                        setFieldValue(`rows`, [initialRowValues])
                                        resetDataInventoryBatches()
                                    }}
                                >
                                    <StyledIcon
                                        sx={{
                                            width: 25,
                                            height: 25,
                                            m: 0,
                                            p: 0
                                        }}
                                    >
                                        <CommonIcons name={icons.edit} />
                                    </StyledIcon>
                                </IconButton>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                                <DatePickerComponent
                                    config={{
                                        name: "documentDate",
                                        label: t("documentDate")
                                    }}
                                    formik={{
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        setFieldValue
                                    }}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"remark"}
                                    label={t("remark")}
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values.remark}
                                    onChange={handleChange}
                                    error={touched.remark && Boolean(errors.remark)}
                                    helperText={touched.remark && errors.remark}
                                />
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        return (
            <form onSubmit={handleSubmit}>
                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={7} textAlign={"left"}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                                {
                                    RenderFormProfile()
                                }
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                                {
                                    RenderFormPayment()
                                }
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={5} textAlign={"left"}>
                        {
                            RenderFormDocument()
                        }
                    </Grid>

                </Grid>
                <StyledCard sx={{ mt: 1 }}>
                    <Grid container rowSpacing={0}>
                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t(`items`)}
                                subTitle={t(`detailInformationAboutTheItemsInvolved`)}
                            />

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            {
                                RenderRows({ values, errors, touched, handleChange, setFieldValue })
                            }

                        </Grid>

                    </Grid>
                </StyledCard>
                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <Button
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                        // loading={isLoadingCreate}
                        >
                            {t('saveChanges')}
                        </Button>
                    </Grid>
                </Grid>

            </form>
        )
    }

    const RenderAll = () => {

        return validateLocationSelection() ?
            (
                RenderForm()
            )
            :
            (
                <LocationSelector
                    config={{
                        title: t(`selectOnly1Location`),
                        description: t(`youHaveToSelectAnyoneOfTheWarehouseLocationToProceed`),
                    }}
                    maxSelect={1}
                    handleOnNext={({ selected }) => {

                        // console.log('selected', selected)

                        setLocationIds([selected[0].id])
                        setFieldValue(`locationId`, selected[0].id)
                        setFieldValue(`locationName`, selected[0].location_name)

                    }}
                />
            )
    }

    return (
        <Box>
            {/* <Typography sx={{ fontSize: 13 }}>
                [dataInventoryBatches : {JSON.stringify(dataInventoryBatches)}]
            </Typography> */}

            {/* <Typography>
                {JSON.stringify(values)}
            </Typography> */}
            {
                getHtmlHead({ routeType, title: headTitles.newCashSales })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("newCashSale")}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: t("cashSales"),
                        props: {
                            href: getRoute('documents/cashSales')
                        }
                    },
                    {
                        displayText: t("newCashSale"),
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderAll()
                    :
                    <CommonRestricted />
            }

            {
                loadDocumentConfig?.show &&

                <LoadFromDocuments
                    fromDocumentId={loadDocumentConfig?.documentId}
                    fromDocumentType={loadDocumentConfig?.documentType}
                    show={loadDocumentConfig?.show}
                    filledSearchKeyword={loadDocumentConfig?.keyword}
                    handleOnCancel={() => {
                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))
                    }}
                    handleOnSelect={(props) => {

                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))

                        // load the data into the state
                        updateStateFromSearchDocument(props)

                    }}
                />
            }

            {
                RenderDocumentTaxPreview()
            }

        </Box>
    )
}